'use client';

import { Button } from '../../../components/ui/button';
import { Share2 } from 'lucide-react';

interface ModuleShareButtonProps {
  title: string;
  content: string;
}

export function ModuleShareButton({ title, content }: ModuleShareButtonProps) {
  const handleShare = async () => {
    if (typeof navigator !== 'undefined' && navigator.share) {
      try {
        await navigator.share({
          title,
          text: content.substring(0, 500) + '...',
          url: window.location.href,
        });
      } catch {
        // Share cancelled or failed - no-op
      }
    } else if (typeof navigator !== 'undefined' && navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(window.location.href);
        alert('Link copied to clipboard');
      } catch {
        // Clipboard failed - no-op
      }
    }
  };

  return (
    <Button variant="outline" size="sm" onClick={handleShare} className="shrink-0">
      <Share2 className="w-4 h-4 mr-2" />
      Share
    </Button>
  );
}
